import { Group } from '@ekhodealer/ekho-common/rev';

import { StatBox } from '@common/components/StatBox';
import { formatNumber, formatPercentage } from '@common/lib/currency';
import { PLACEHOLDER } from '@common/lib/strings';

import { useGetConversationStats } from '../api/useGetConversationStats';

export function ConversationStats() {
	const { data, isLoading } = useGetConversationStats();

	const stats = data?.stats;
	const placeholder = isLoading ? PLACEHOLDER : undefined;

	return (
		<Group itemsSpacing='16' noWrap itemsAlignX='stretch' itemsAlignY='stretch'>
			<StatBox
				title='Total conversations (last 30 days)'
				detail={formatNumber(stats?.totalConversations, placeholder)}
			/>
			<StatBox
				title='AI-handled rate'
				detail={formatPercentage(stats?.aiHandledRate, placeholder)}
			/>
			<StatBox
				title='Lead conversion rate'
				detail={formatPercentage(stats?.leadConversionRate, placeholder)}
			/>
			<StatBox
				title='Appointment booking rate'
				detail={formatPercentage(stats?.appointmentBookingRate, placeholder)}
			/>
		</Group>
	);
}
